import { combineReducers } from "redux";
import { IRootReducer } from "../Models/IRootReducer";
import { appReducer } from "../View/Products/Reducers/AppReducer";
import { loginReducer } from "../View/Products/Reducers/LoginReducer";
import { notificationsReducer } from "../View/Products/Reducers/NotificationsReducer";
import { bookmarks } from "./BookmarkReducer";
import { companySupportTeamStore } from "./CompanySupportTeamReducer";
import { digitalShare } from "./DigitalShareReducer";
import { mobilyticsReportOutput } from "./GPSInsightsReducer";
import { factorReducer } from "./FactorReducer";
import { leftNav } from "./LeftNavReducer";
import { loadScout } from "./LoadScoutReducer";
import { mapSettings } from "./MapSettingsReducer";
import { mobilyticsPlaces } from "./MobilyticsPlacesReducer";
import { myData } from "./MyDataReducer";
import { reportMap } from "./ReportMapReducer";
import { reports } from "./ReportsReducer";
import { matchReportOutput } from "./RetailMatchReducer";
import { salesPerformanceReducer } from "./SalesPerformanceReducer";
import { session } from "./SessionReducer";
import { tableauReducer } from "./TableauReducer";
import { territoryManagement } from "./TerritoryManagementReducer";
import { toolbox } from "./ToolboxReducer";
import { twoByTwo } from "./TwoByTwoReducer";
import { userManagement } from "./UserManagementReducer";
import { userPreferencesStore } from "./UserPreferencesReducer";
import { userProfile } from "./UserProfileReducer";
import { user } from "./UserReducer";
import { notificationWorkflowReducer } from "./NotificationWorkflowReducer";

export const rootReducer = combineReducers<IRootReducer>({
    user,
    twoByTwo,
    mobilyticsReportOutput,
    factorReducer,
    matchReportOutput,
    reportMap,
    myData,
    userPreferencesStore,
    bookmarks,
    loadScout,
    userManagement,
    session,
    tableauReducer,
    reports,
    territoryManagement,
    userProfile,
    companySupportTeamStore,
    salesPerformanceReducer,
    leftNav,
    mapSettings,
    toolbox,
    mobilyticsPlaces,
    digitalShare,
    appReducer,
    loginReducer,
    notificationsReducer,
    notificationWorkflowReducer,
});

export type RootState = ReturnType<typeof rootReducer>;